module.exports = __webpack_public_path__ + "img/interac-online.4f114467.svg";